export default "__VITE_ASSET__BgTJAy7C__"